import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const BannerSkeleton = () => {
  return (
    <div className="d-flex flex-wrap w-100">
      <div className="col-xxl-2 col-lg-3 col-sm-4 col-6 w-100">
        <div className=" w-100  ">
          <div className=" d-flex flex-column">
            <Skeleton width="100%" height="16em" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerSkeleton;
